import { render, staticRenderFns } from "./PinglunDetail.vue?vue&type=template&id=77f3ff5b&scoped=true&"
import script from "./PinglunDetail.vue?vue&type=script&lang=js&"
export * from "./PinglunDetail.vue?vue&type=script&lang=js&"
import style0 from "./PinglunDetail.vue?vue&type=style&index=0&id=77f3ff5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f3ff5b",
  null
  
)

export default component.exports